import StatusBadge from "../../generals/StatusBadge";

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function DetailRow({ label, value }) {
  return (
    <div className="mt-2 flex flex-row items-start text-gray-700">
      <div className="w-[140px] flex-shrink-0 text-sm mr-2">{label}</div>
      <div className="text-xs font-bold break-words">{formatValue(value)}</div>
    </div>
  );
}

function EmployeeTypeOverview({ employeeType }) {
  if (!employeeType) return null;

  return (
    <div className="border-[1px] border-gray-200 rounded-lg p-4 @container">
      <div className="w-full @xl:grid @xl:grid-cols-5 @xl:gap-4">
        <div className="mt-3 @xl:col-span-3">
          <div className="text-gray-600 font-bold text-xl">
            {employeeType.name}
          </div>
          <DetailRow label="Employee Type ID" value={employeeType.id} />
          <DetailRow label="Name" value={employeeType.name} />
          <div className="mt-2 flex flex-row items-center text-gray-700">
            <div className="w-[140px] flex-shrink-0 text-sm mr-2">Status</div>
            <StatusBadge
              statusId={employeeType.statusId}
              statusName={employeeType.statusName}
            />
          </div>
          <DetailRow label="Created By" value={employeeType.createdBy} />
          <DetailRow label="Created At" value={employeeType.createdAt} />
          <DetailRow label="Last Changed By" value={employeeType.lastChangedBy} />
          <DetailRow label="Last Changed At" value={employeeType.lastChangedAt} />
        </div>
      </div>
    </div>
  );
}

export default EmployeeTypeOverview;
